import {
  HomePage, Page404,
  HatcheryIndex, HatcheryAdd, HatcheryDetail,
  KolamIndex, KolamAdd, KolamDetail,
  TambakIndex, TambakAdd, TambakDetail
} from '../pages';
import { withNavigationWatcher } from '../contexts/navigation';

const routes = [
  {
    path: '/404',
    element: Page404
  },
  {
    path: '/',
    element: HomePage
  },
  {
    path: '/master/hatchery',
    element: HatcheryIndex
  },
  {
    path: '/master/hatchery/add',
    element: HatcheryAdd
  },
  {
    path: '/master/hatchery/detail/:id',
    element: HatcheryDetail
  },
  {
    path: '/master/kolam',
    element: KolamIndex
  },
  {
    path: '/master/kolam/add',
    element: KolamAdd
  },
  {
    path: '/master/kolam/detail/:id',
    element: KolamDetail
  },
  {
    path: '/master/tambak',
    element: TambakIndex
  },
  {
    path: '/master/tambak/add',
    element: TambakAdd
  },
  {
    path: '/master/tambak/detail/:id',
    element: TambakDetail
  },
];

export default routes.map(route => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path)
  };
});
